import type { CSSProperties } from 'react';
import './Skeleton.css';

type SkeletonVariant = 'card' | 'text' | 'avatar' | 'line';

interface Props {
  variant?: SkeletonVariant;
  width?: string | number;
  height?: string | number;
  className?: string;
  style?: CSSProperties;
  /** Aspect ratio for `card` variant (e.g. 4/3). */
  aspectRatio?: number | string;
}

/**
 * Subtle shimmer placeholder. Respects prefers-reduced-motion (falls back
 * to a static muted fill). Tokenised - no hard-coded colours.
 */
export function Skeleton({
  variant = 'line',
  width,
  height,
  className,
  style,
  aspectRatio,
}: Props) {
  const merged: CSSProperties = { ...style };
  if (width !== undefined) merged.width = typeof width === 'number' ? `${width}px` : width;
  if (height !== undefined) merged.height = typeof height === 'number' ? `${height}px` : height;
  if (aspectRatio !== undefined) merged.aspectRatio = String(aspectRatio);

  return (
    <span
      className={`skel skel--${variant} ${className ?? ''}`}
      style={merged}
      aria-hidden="true"
    />
  );
}
